<template>
  <div>
    <!-- 单个终端下拨对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="visible"
      width="400px"
      @close="handleClose"
    >
      <el-form label-width="100px">
        <el-form-item v-if="actionType === 'hq_allocate'" label="分公司：">
          <el-select v-model="formData.groupId" placeholder="请选择" clearable>
            <el-option
              v-for="item in groupList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="actionType === 'branch_allocate'" label="业务员：">
          <el-select v-model="formData.salesId" placeholder="请选择" clearable>
            <el-option
              v-for="item in salesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  allocateOne,
  getGroupListToTerminal,
  getUserListByLogin,
} from "@/api/erp/terminal";

export default {
  name: "TerminalSingleOperationDialog",
  data() {
    return {
      visible: false,
      actionType: "", // hq_allocate 或 branch_allocate
      submitLoading: false,
      currentRow: null, // 当前操作的行数据
      formData: {
        operationType: "",
        groupId: "",
        salesId: "",
        salesName: "",
      },
      groupList: [],
      salesList: [],
    };
  },
  computed: {
    dialogTitle() {
      if (this.actionType === "hq_allocate") {
        return "总部下拨";
      } else if (this.actionType === "branch_allocate") {
        return "分部下拨";
      }
      return "";
    },
  },
  watch: {
    "formData.salesId"(val) {
      // 当选择业务员时，自动获取并存储业务员名称
      if (val) {
        const selectedSales = this.salesList.find((item) => item.id === val);
        this.formData.salesName = selectedSales ? selectedSales.name : "";
      } else {
        // 清除业务员时，也清除业务员名称
        this.formData.salesName = "";
      }
    },
  },
  methods: {
    open(row, actionType) {
      this.visible = true;
      this.actionType = actionType;
      this.currentRow = row;

      if (actionType === "hq_allocate") {
        this.getGroupList();
        this.formData.operationType = 0; // 总部下拨
      } else if (actionType === "branch_allocate") {
        this.getUserList();
        this.formData.operationType = 1; // 分公司下拨
      }
    },
    // 获取分公司列表
    async getGroupList() {
      try {
        const { data } = await getGroupListToTerminal();
        this.groupList = data || [];
      } catch (error) {
        this.$message.error("获取分公司列表异常");
        this.groupList = [];
      }
    },
    // 获取业务员列表
    async getUserList() {
      try {
        const { data } = await getUserListByLogin();
        this.salesList = data || [];
      } catch (error) {
        this.$message.error("获取业务员列表异常");
        this.salesList = [];
      }
    },
    // 提交下拨
    async handleSubmit() {
      if (this.submitLoading) {
        return;
      }

      if (this.actionType === "hq_allocate" && !this.formData.groupId) {
        this.$message.warning("请选择分公司");
        return;
      }

      if (this.actionType === "branch_allocate" && !this.formData.salesId) {
        this.$message.warning("请选择业务员");
        return;
      }

      this.submitLoading = true;
      const param = {
        terminalId: this.currentRow.id,
        operationType: this.formData.operationType,
      };

      if (this.actionType === "hq_allocate") {
        param.groupId = this.formData.groupId;
      } else if (this.actionType === "branch_allocate") {
        param.salesId = this.formData.salesId;
        param.salesName = this.formData.salesName;
      }

      try {
        await allocateOne(param);
        this.$message.success("下拨成功");
        this.$emit("success");
        this.handleClose();
      } catch (error) {
        this.$message.error("下拨失败");
      } finally {
        this.submitLoading = false;
      }
    },
    // 关闭对话框
    handleClose() {
      this.visible = false;
      this.resetForm();
    },
    // 重置表单
    resetForm() {
      Object.assign(this.$data, this.$options.data());
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
